import BatchDelete from 'components/BatchDelete';
import FileImportExport from 'components/FileImportExport';
import React from 'react'
import { FaBolt, FaPlus, FaRandom } from 'react-icons/fa';
import Button from "@leafygreen-ui/button"

export default function PrintedFilmsInventoryHeader({ showModal, importHandler, exportHandler, selectedExportMode, setSelectedExportMode, batchDeleteHandler, showUnderLowStock }) {
  return (
    <div className="page-header card p-10">
      <div className='btn-menu-list'>
        <Button
          variant="primary"
          className="swing-icon"
          title="Reload"
          leftGlyph={<FaBolt />}
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </Button>

        <Button
          variant="primary"
          className="swing-icon"
          leftGlyph={<FaPlus />}

          onClick={() => {
            showModal("_createPrintedFilm");
          }}
        >
          Add
        </Button>

        <FileImportExport
          importHandler={importHandler}
          exportHandler={exportHandler}
          selectedExportMode={selectedExportMode}
          setSelectedExportMode={setSelectedExportMode}
        />

        <BatchDelete batchDeleteHandler={batchDeleteHandler} />
        <Button
          variant="primary"
          className="swing-icon"
          leftGlyph={<FaRandom />}
          onClick={showUnderLowStock}
        >
          Show under low stock threshold
        </Button>
      </div>

    </div>
  )
}
